import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { concatMap, count, EMPTY, expand, filter, finalize, takeWhile, tap } from 'rxjs';
import {  PlanType, StatusType } from 'src/app/enums/oem-management-enum';
import { MasterDataService } from 'src/app/services/master-data.service';
import { GeographicalType } from 'src/app/enums/product-enum';
import { City, Continent, Country, State } from 'src/app/models/master-data.model';
import { CustomChip, GeographicalChip } from 'src/app/models/product-model';
import { SubScriptionDetails } from 'src/app/models/subscription-model';
import { SubscriptionsService } from 'src/app/services/shared/subscriptions/subscriptions.service';
import { MatSelect } from '@angular/material/select';
import Swal from 'sweetalert2';
import { OemManagementService } from 'src/app/services/super-admin/oem-management.service';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.html',
  styleUrls: ['./filter-popup.component.css']
})
export class FilterPopupComponent implements OnInit {

  filterForm!: FormGroup;
  planTypes = Object.values(PlanType);
  statusTypes = Object.values(StatusType);
  countries!: Country[];
  states!: State[];
  cities!: City[];
  searchText: string = '';
  chips: GeographicalChip[] = [];
  oldChips: GeographicalChip[] = [];

  selectedContinents: Continent[] = [];
  selectedCountries: Country[] = [];
  selectedStates: State[] = [];
  selectedCities: City[] = [];
  selectedCreatedBy: string[] = [];
  subscriptionPlans: SubScriptionDetails[] = [];
  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  createdByControl = new FormControl();
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  filteredCreatedBy: any[] = [];
  isCountrySelected: boolean = false;
  isStateSelected: boolean = false;
  createdBy: any[] = [];
  @Output() clearChipsAndFilters = new EventEmitter<any>();
  
  emailStatus: { label: string, value: boolean }[] = [
    { label: 'Verified', value: true },
    { label: 'Not Verified', value: false }
  ];

  constructor(private dialogRef: MatDialogRef<FilterPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: { filterData: any, chips: any, type: any }, private fb: FormBuilder, private masterDataService: MasterDataService,
    private subscriptionsService: SubscriptionsService,
    private oemManagementService: OemManagementService,
    private distributorService: DistributorService,
    private datePipe: DatePipe
  ) { }

  async ngOnInit() {
    this.filterForm = this.fb.group({
      startDate: [],
      endDate: [],
      country: [],
      state: [],
      city: [],
      planType: [''],
      status: [''],
      createdBy: [],
      emailVerifiedStatus:['']
    });

    this.chips = this.data.chips;
    this.oldChips = this.data.chips;

    if (this.data.filterData) {
      this.filterForm.patchValue(this.data.filterData);

    }
    this.filterForm.get('planType')?.valueChanges.subscribe(planType => {
      if (planType) {
        this.handlePlanTypeChange(planType);
      }
    })
    this.filterForm.get('status')?.valueChanges.subscribe(status => {
      if (status) {
        this.handleStatusChange(status);
      }
    });

    this.filterForm.get('startDate')?.valueChanges.subscribe(startDate => {
      this.filterForm.get('endDate')?.valueChanges.subscribe(endDate => {
        let value = '';
        if(startDate && endDate) {
          value = `Date Range: ${this.datePipe.transform(this.filterForm.get('startDate')?.value, 'MM/dd/yyyy')} - ${this.datePipe.transform(this.filterForm.get('endDate')?.value, 'MM/dd/yyyy')}`;
          this.handleDateChange(value);
        }
      })
    });
      
    this.filterForm.get('emailVerifiedStatus')?.valueChanges.subscribe(emailVerifiedStatus => {
      if (emailVerifiedStatus) 
      {
        this.handleEmailStatusChange(emailVerifiedStatus);
      }
    });
    
    await this.loadMasterData();

    this.countryControl.valueChanges.subscribe(value => {
      if (!value?.countryName) {
        if (this.countries) {
          this.filteredCountries = this.countries.filter(country =>
          country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    }
    });
    this.stateControl.valueChanges.subscribe(value => {
      const input = this.normalizeText(typeof value === 'string' ? value : value?.stateName || '');
      
      if (this.states) {
        this.filteredStates = this.states.filter(state =>
          this.normalizeText(state.stateName).includes(input)
        );
      }
    });
    
    this.cityControl.valueChanges.subscribe(value => {
      if (!value?.cityName) {
        if (this.cities) {
          this.filteredCities = this.cities.filter(city =>
            this.normalizeText(city.cityName).includes(value?.toLowerCase() || '')
        );
      }
    } 
    });
    
    this.createdByControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredCreatedBy = this.createdBy?.filter(createdBy =>
          createdBy.name.toLowerCase().includes(value?.toLowerCase() || '')
        ) || [];
      } else {
        this.filteredCreatedBy = this.createdBy;
      }
    });

    if(this.data.type === 'oem') {
      this.getOemData();
    } else if (this.data.type === 'distributor') {
      this.getDistributoCreatedByData();
    }
  }

  normalizeText(value: string): string {
    return value?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  
  handleStatusChange(status: string) {
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.STATUS);
    const statusChip: CustomChip = {
      id: 0,
      name: status,
      type: GeographicalType.STATUS,
      priority: 7,
      isGeographical: false
    };
    this.addNewChip(statusChip);
  }
  handleDateChange(status: string) {
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.DATE);
    const dateChip: CustomChip = {
      id: 0,
      name: status,
      type: GeographicalType.DATE,
      priority: 5,
      isGeographical: false
    };
    this.addNewChip(dateChip);
  }
  handlePlanTypeChange(planType: string) {
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.PLAN);
    const planTypeChip: CustomChip = {
      id: 0,
      name: planType,
      type: GeographicalType.PLAN,
      priority: 6,
      isGeographical: false
    };
    this.addNewChip(planTypeChip);
  }
  handleEmailStatusChange(emailVerifiedStatus: { label: string, value: boolean }) {
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.EMAIL_VERIFIED);
    if (emailVerifiedStatus) {
      const activeChip: CustomChip = {
        id: 0,
        name: emailVerifiedStatus.label, 
        type: GeographicalType.EMAIL_VERIFIED,
        priority: 9,
        isGeographical: false
      };
      this.addNewChip(activeChip);
    }
  }
  
  submitFilter() { 
    const filterData = {
      continents: this.selectedContinents?.map(c => c.continentName),
      countries: this.selectedCountries?.map(c => c.countryName),
      states: this.selectedStates?.map(c => c.stateName),
      cities: this.selectedCities?.map(c => c.cityName),
      startDate: this.filterForm.value.startDate,
      endDate: this.filterForm.value.endDate,
      planType: this.filterForm.value.planType,
      status: this.filterForm.value.status,
      createdBy: Array.isArray(this.filterForm.value.createdBy)
        ? this.filterForm.value.createdBy
        : [],
      emailVerifiedStatus: this.filterForm.value.emailVerifiedStatus?.value ?? null
    };
    const isAllFiltersEmpty = Object.entries(filterData).every(([_, val]) => {
      if (Array.isArray(val)) return val.length === 0;
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim().length === 0;
      return false;
    });
    
    if (isAllFiltersEmpty) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Filters',
        text: 'Please select at least one filter!',
        confirmButtonText: 'OK',
      });
      return;
    }
    const payload = {
      filterData : {
        continents: this.selectedContinents?.map(c => c.continentName),
        countries: this.selectedCountries?.map(c => c.countryName),
        states: this.selectedStates?.map(c => c.stateName),
        cities: this.selectedCities?.map(c => c.cityName),
        startDate: this.filterForm.value.startDate,
        endDate: this.filterForm.value.endDate,
        planType: this.filterForm.value.planType,
        status: this.filterForm.value.status,
        createdBy: Array.isArray(this.filterForm.value.createdBy) 
        ? this.filterForm.value.createdBy 
        : [],
        emailVerifiedStatus: this.filterForm.value.emailVerifiedStatus?.value ?? null
      },
      chips : this.chips,
    }
     this.dialogRef.close(payload);

  }

  clearFilter() {
    this.chips = [];
    this.filterForm.reset();
    const filters = {
      continents: [],
      countries: [],
      states: [],
      cities: [],
      startDate: null,
      endDate: null,
      planType: null,
      status: null,
      createdBy:[],
      emailVerifiedStatus: null
    }
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.DATE);
    this.selectedCountries = [];
    this.selectedStates = [];
    this.filteredStates = [];
    this.filteredCities = [];
    this.clearChipsAndFilters.emit({clearingChips:this.chips, clearingFilters: filters});
    this.highlightCountry = false;
    this.highlightState = false;
  }

  private async loadMasterData() {
    this.loadCountries(['']);
    await this.getSubsctiptionStatus();
  }

  loadCountries(continentNames: string[]) {
    let pageNumber = 0;
    let pageSize = 200;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', continentNames)
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; 
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', continentNames);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        allCountries.sort((a, b) =>
          a.countryName.toLowerCase().localeCompare(b.countryName.toLowerCase())
        );
        this.countries = allCountries;
        this.filteredCountries = allCountries;
      });
  }

  loadStates(countryNames: string[]) {
    if (!countryNames || countryNames.length === 0) {
      this.states = [];
      this.filteredStates = [];
      this.isCountrySelected = false;
      this.isStateSelected = false; 
      return;
    }

    let pageNumber = 0;
    let pageSize = 100;
    let allStates: any[] = [];
    let morePages = true;

    this.masterDataService.getStates(pageNumber, pageSize, '', countryNames)
      .pipe(
        expand(response => {
          if (response.data.length === 0) {
            morePages = false;
            return EMPTY;
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', countryNames);
        }),
        finalize(() => {
          allStates.sort((a, b) =>
            a.stateName.toLowerCase().localeCompare(b.stateName.toLowerCase())
          );
          this.states = allStates;
          this.filteredStates = this.states.length > 0 ? [...this.states] : [];

          this.isCountrySelected = countryNames.length > 0;
        })
      )
      .subscribe();
}
  onCountryChange(event: any) {
    const country = event?.option?.value;

    if (!country) {
      this.states = [];
      this.filteredStates = [];
      return;
    }

    if (!this.selectedCountries?.some(c => c.id === country.id)) {
      this.selectedCountries?.push(country);
    }

    const countryNames = this.selectedCountries?.map(c => c.countryName);

    this.loadStates(countryNames);
    this.removeContinentForCountry(country);
    const x = this.createChipStructure(country.countryName, GeographicalType.COUNTRY, 2);
    this.stateControl.reset();
    this.addNewChip(x);
    this.highlightCountry = false;
    this.showWarning = false;
    this.highlightState = false;

    this.countryControl.reset();
    this.filteredStates = [];
  }

  loadCities(stateNames: string[]) {
    if (!stateNames || stateNames.length === 0) {
        this.cities = [];
        this.filteredCities = [];
        return;
    }

    let pageNumber = 0;
    let pageSize = 100;
    let allCities: any[] = [];
    let morePages = true;

    this.masterDataService.getCities(pageNumber, pageSize, '', stateNames)
      .pipe(
        expand(response => {
          if (response.data.length === 0) {
            morePages = false;
            return EMPTY;
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', stateNames);
        }),
        finalize(() => {
          allCities.sort((a, b) =>
            a.cityName.toLowerCase().localeCompare(b.cityName.toLowerCase())
          );
          this.cities = allCities;
          this.filteredCities = this.cities.length > 0 ? [...this.cities] : [];
          this.isStateSelected = this.filteredCities.length > 0; 
        })
      )
      .subscribe();
}
  
  onStateChange(state: State) {
    if (!this.selectedStates?.some(c => c.id === state.id)) {
      this.selectedStates?.push(state);
    }
     const stateNames = this.selectedStates?.map(c => c.stateName);
    this.loadCities(stateNames);
    this.addNewChip(this.createChipStructure(state.stateName, GeographicalType.STATE, 3));
    this.stateControl.reset();
    this.highlightState  = false;
    this.showWarning = false;
  }
  
  onCityChange(city: City) {
    if (!this.selectedCities?.some(c => c.id === city.id)) {
      this.selectedCities?.push(city);
    }
    this.addNewChip(this.createChipStructure(city.cityName, GeographicalType.CITY, 4));
    this.cityControl.reset();
  }
  receiveSearchText(searchText: string): void {
    this.searchText = searchText;
  }
  
  remove(chip: GeographicalChip) {
    const index = this.chips.indexOf(chip);
    if (index >= 0) {
      this.chips = this.chips.filter((chipL: any, id: number) => id !== index);
      switch (chip.type) {
        case GeographicalType.CONTINENT:
          this.filterForm.patchValue({ continent: '' });
          this.selectedContinents = this.selectedContinents.filter(c => c.continentName !== chip.name);
          break;
          case GeographicalType.COUNTRY:
            
            this.selectedCountries = this.selectedCountries.filter(c => c.countryName !== chip.name);
            this.filterForm.patchValue({ country: this.selectedCountries[this.selectedCountries.length - 1] || '' });
            this.loadStates(this.selectedCountries.map(c => c.countryName));
            this.loadCities(this.selectedStates.map(c => c.stateName));
            break;
            case GeographicalType.STATE:
              const state = this.states.find(c => c.id === chip.id);
              if (state) {
                const countryForSelectedState = this.countries.find(c => c.countryName === state.countryName);
                const countryAvailableInFilter = this.chips.find(c => c.type === GeographicalType.COUNTRY && c.name === countryForSelectedState?.countryName);
                if (countryForSelectedState && countryAvailableInFilter) {
                  this.selectedCountries.push(countryForSelectedState);
                }
              }
              this.selectedStates = this.selectedStates.filter(c => c.stateName !== chip.name);
              this.filterForm.patchValue({ state: this.selectedStates[this.selectedStates.length - 1] || '' });
              this.loadCities(this.selectedStates.map(c => c.stateName));
              break;
              case GeographicalType.CITY:
                const city = this.cities.find(c => c.id === chip.id);
                if (city) {
                  const stateForSelectedCity = this.states.find(c => c.stateName === city.stateName);
                  const stateAvailableInFilter = this.chips.find(c => c.type === GeographicalType.STATE && c.name === stateForSelectedCity?.stateName);
            if (stateForSelectedCity && stateAvailableInFilter) {
              this.selectedStates.push(stateForSelectedCity);
            }
          }
          this.selectedCities = this.selectedCities.filter(c => c.cityName !== chip.name);
          this.filterForm.patchValue({ city: this.selectedCities[this.selectedCities.length - 1] || '' });
          break;
          case GeographicalType.STATUS:
            this.filterForm.patchValue({ status: '' });
            break;

            case GeographicalType.CREATED_BY:
           this.selectedCreatedBy = this.selectedCreatedBy.filter(name => name !== chip.name);
           const remainingCreatedByIds = this.chips
          .filter(c => c.type === GeographicalType.CREATED_BY && c.name !== chip.name)
          .map(c => c.id);
           this.filterForm.patchValue({ createdBy: remainingCreatedByIds });
           break;


              case GeographicalType.EMAIL_VERIFIED:
                this.filterForm.patchValue({ emailVerifiedStatus: '' });
                break;
                case GeographicalType.PLAN:
                  this.filterForm.patchValue({ planType: '' });
                  break;
                default:
                  break;
                }
              }
            }
            addNewChip(newChip: GeographicalChip) {
              const chipExists = this.chips.some(chip => 
                chip.name === newChip.name && chip.type === newChip.type
              );
              
              if (!chipExists) {
                this.chips=[...this.chips, newChip]
              }
            }
            
            createChipStructure(name: string, type: GeographicalType, priority: number, id: number = 0): GeographicalChip {
              return {
                id: id,
                name: name,
                type: type,
                priority: priority
              };
            }
            
            removeContinentForCountry(country: Country) {
              const continentCode = country.continentCode;
              this.selectedContinents = this.selectedContinents?.filter(continent => continent.continentCode !== continentCode);
            }
            
            removeCountryForState(state: State) {
              const countryName = state.countryName;
              
              const country = this.selectedCountries?.find(c => c.countryName === countryName);
              if (country) {
                this.selectedCountries = this.selectedCountries?.filter(country => country.countryName !== countryName);
              }
            }

  removeStateForCity(city: City) {
    const stateName = city.stateName;
    
    const state = this.selectedStates?.find(c => c.stateName === stateName);
    if (state) {
      this.selectedStates = this.selectedStates?.filter(state => state.stateName !== stateName);
    }
  }
  
  getSubsctiptionStatus(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.subscriptionsService.getAllSubscriptions().subscribe(data => {
        this.subscriptionPlans = data.data
        resolve();
      })
    })
  }
  cancel() {
    this.chips = [];
    this.filterForm.reset();
    const filters = {
      continents: [],
      countries: [],
      states: [],
      cities: [],
      startDate: null,
      endDate: null,
      planType: null,
      status: null,
      createdBy: [],
      emailVerifiedStatus: null
    }
    this.chips = this.chips.filter(chip => chip.type !== GeographicalType.DATE);
    this.clearChipsAndFilters.emit({clearingChips:this.chips, clearingFilters: filters});
    this.filterForm.patchValue(this.data.filterData);
    this.dialogRef.close(null);
  }
  dropDownData: any[] = [];
  
  getOemData() {
    this.oemManagementService.getCreatedBy().subscribe(data => {
      this.createdBy = data.data
      this.filteredCreatedBy = data.data
    })
  }
    handleCreatedByChange(selectedUser: any) {  
      if (!selectedUser || !selectedUser.id) return; 
      const existingChip = this.chips.find(chip => chip.id === selectedUser.id);
      if (!existingChip) {
        const createdByChip: CustomChip = {
          id: selectedUser.id,
          name: selectedUser.name,
          type: GeographicalType.CREATED_BY,
          priority: 8,
          isGeographical: false
        };
        this.chips = [...this.chips, createdByChip];
        const existingCreatedBy = this.filterForm.value.createdBy || [];
        this.filterForm.patchValue({ createdBy: [...existingCreatedBy, selectedUser.id] });
        this.addNewChip(this.createChipStructure(selectedUser.name, GeographicalType.CREATED_BY, 8));
      }
      this.createdByControl?.setValue(null);
    }
    
    displayFn(user: any): string {
      return user ? user.name : '';
    }

    getDistributoCreatedByData() {
      this.distributorService.getCreatedBy().subscribe(data => {
        this.createdBy = data.data
        this.filteredCreatedBy = data.data
      })
  }

    showWarning = false;
    highlightCountry = false;
    highlightState = false;

    onCountryFocus(): void {
      const country = this.selectedCountries;
      const isCountrySelected = country && country.length > 0;      
      if (!isCountrySelected) {
        this.showWarning = true;
      } 
    }
    onStateFocus(): void {
      const country = this.selectedCountries;
      const isCountrySelected = country && country.length > 0;
      this.highlightCountry = !isCountrySelected;
    
      if (!isCountrySelected) {
        this.showWarning = true;
      } else {
        this.showWarning = false;
      }
    }

    onCityFocus(): void {
      const country = this.selectedCountries;
      const state = this.selectedStates;
      
      const isCountrySelected = country && country.length > 0;
      const isStateSelected = state && state.length > 0;
      
      this.highlightCountry = !isCountrySelected;
      this.highlightState = !isStateSelected;
      
      if (!isCountrySelected || !isStateSelected) {
        this.showWarning = true;
      } else {
        this.showWarning = false;
      }
    }

    onCountrySelected(country: any): void {
      this.countryControl.setValue(country); 
      this.onCityFocus(); 
    }
    
    onStateSelected(state: any): void {
      this.stateControl.setValue(state);
      this.highlightState = false;
      this.showWarning = false; 
    }
  }
  